import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { getPageTitle } from '../../utils/pageTitle';
import { BRAND_NAME } from '../../constants/layout';
import { SEO_BUSINESS_INFO } from '../../constants/seo';

const DEFAULT_DESCRIPTION = SEO_BUSINESS_INFO.description;

export type SeoProps = {
  title?: string;
  metaDescription?: string;
  ogImage?: string;
  skipBrandName?: boolean;
};

export const Seo = ({ title, metaDescription, ogImage, skipBrandName = false }: SeoProps) => {

  const pageTitle = getPageTitle({ title, skipBrandName });
  const description = metaDescription ?? DEFAULT_DESCRIPTION;

  const {
    i18n: { language }
  } = useTranslation();

  return (
    <Helmet>
      <html lang={language} />
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={BRAND_NAME} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <script type="application/ld+json">{JSON.stringify(SEO_BUSINESS_INFO)}</script>
    </Helmet>
  );
};
